import { Alert } from '@mui/material'
import type { FC } from 'react'
import React, { useContext } from 'react'
import styled from 'styled-components'

import DangerPanelButton from '@/components/DangerPanelButton'
import { AlternateButton } from '@/components/DEPRECATED_UI/Button'
import SlideInSidebar from '@/components/DEPRECATED_UI/SlideInSidebar'
import ctx from '@/context/AppContext'
import {
  useResetSectionMutation,
  ResetableSection,
} from '@/lib/apollo/mutation/reset-section'
import { ADVERSE_CREDIT_FRAUD_ESCALATION_WARNING } from '@/utils/adverseCredit'
import { Colours } from '@/utils/styles'

const ErrorContainer = styled.div`
  strong {
    color: ${Colours.red};
  }
`

interface Props {
  customerId: string
  applicationId: string
  subjectId: string
  hasAdverseCredit: boolean
  onClose: () => void
}

const ResetSidebar: FC<Props> = ({
  customerId,
  applicationId,
  subjectId,
  hasAdverseCredit,
  onClose,
}) => {
  const { personId } = useContext(ctx)

  const [handleResetSection, { loading, error, data }] = useResetSectionMutation()

  const onSubmit = () => {
    handleResetSection({
      variables: {
        customerId,
        applicationId,
        subjectId,
        section: ResetableSection.Residential,
        userId: personId ?? '',
      },
    })
  }

  return (
    <SlideInSidebar
      onClose={() => onClose()}
      header={<h1>Reset Residential</h1>}
      content={
        data ? (
          <p>The residential section has been reset.</p>
        ) : (
          <>
            {hasAdverseCredit && (
              <Alert severity="warning" variant="standard" sx={{ mb: 2 }}>
                {ADVERSE_CREDIT_FRAUD_ESCALATION_WARNING}
              </Alert>
            )}
            <p>
              You are resetting the residential section for this applicant. The applicant
              will receive an email requesting them to re-submit their residential
              history.
            </p>
            <p>This action will:</p>
            <ul>
              <li>Delete their previous submission</li>
              <li>Notify the agent on this request</li>
              <li>Re-run a credit check when completed</li>
              <li>Remove any validation done on the credit check section</li>
            </ul>
          </>
        )
      }
      footer={
        <>
          {error && <ErrorContainer>An unexpected error occurred.</ErrorContainer>}
          <div className="side-by-side-flex-end">
            <AlternateButton onClick={onClose}>Cancel</AlternateButton>
            {!data && (
              <DangerPanelButton disabled={loading} onClick={onSubmit}>
                Reset Section
              </DangerPanelButton>
            )}
          </div>
        </>
      }
    />
  )
}

export default ResetSidebar
